import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AbstractService} from './abstract.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoService extends AbstractService {

  constructor(public http: HttpClient) {
    super('v1/notificacoes', http);
  }

  getNotificacoes(page: number, size: string, filter: string, tipo: string) {
    let params = new HttpParams();
    params = params.set('page', page.toString());
    params = params.set('size', size);
    params = params.set('filtro', filter);
    if (tipo === 'lidas') {
      params = params.set('lido', '' + true);
    }
    if (tipo === 'naolidas') {
      params = params.set('lido', '' + false);
    }
    return this.getBy(params);
  }

}
